import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { getBlob, getStorage, ref } from 'firebase/storage';
import { downloadBlob } from '@/utils/downloadBlob';
import { useDispatch } from 'react-redux';
import { showToast } from '@/features/toast/toastSlice';

/**
 * A document icon that downloads the file an import was started from (its `storagePath`,
 * under adminImports/), with the Storage SDK as the signed-in admin: only Folio admins can
 * read it (storage.rules), and it's saved under the uploaded file's name. Used beside the file name in the import
 * history and the report. The click doesn't reach the row it's in, so it doesn't open it.
 */
export const ImportFileButton = ({ storagePath, fileName }) => {
	const dispatch = useDispatch();

	const handleClick = async (event) => {
		event.stopPropagation();
		try {
			// Read as the signed-in admin, so storage.rules apply; no download link (token) is
			// used, and the backend removes the file's token as soon as it reads the file
			const blob = await getBlob(ref(getStorage(), storagePath));
			downloadBlob(blob, fileName);
		} catch (error) {
			console.error('Could not download the import file', error);
			dispatch(
				showToast({
					message: "Couldn't download the file. Please try again.",
					error: true,
				}),
			);
		}
	};

	return (
		<Tooltip title={`Download ${fileName}`}>
			<IconButton
				color='primary'
				size='small'
				onClick={handleClick}
				aria-label={`Download ${fileName}`}
			>
				<DescriptionOutlinedIcon fontSize='small' />
			</IconButton>
		</Tooltip>
	);
};
